define.alias("shared/components/shared/carousel/controls", "calendar/components/shared/carousel/controls");